import type { ReactNode } from 'react';
import React, { useEffect, useRef } from 'react';
type Props = {
  children: ReactNode;
  className?: string;
  onClick: () => void;
  shard?: {
    current: HTMLElement | null | undefined;
  } | null;
};
export const ClickOutside = ({ children, className, onClick, shard, ...rest }: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      const { current } = ref;
      const shardElement = shard?.current;
      const clickedElement = e.target;
      if (current && clickedElement instanceof Node && !current.contains(clickedElement)) {
        if (shardElement) {
          return !shardElement.contains(clickedElement) ? onClick() : undefined;
        }

        onClick();
      }
    };

    document.addEventListener('click', onClickOutside);
    return () => {
      document.removeEventListener('click', onClickOutside);
    };
  }, [onClick, shard]);
  return (
    <div {...rest} className={className} ref={ref}>
      {children}
    </div>
  );
};
